// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__JwtoB","info":"Panel_info__CYBs7","note":"Panel_note__nD833","close":"Panel_close__bxtJ+","btns":"Panel_btns__3mdyB","button":"Panel_button__2wMhp"};